/**
 * Payment Lock — Tamper Guard
 * Re-locks storefront if overlay/assets are removed without authorized disable password.
 */

(function () {
  'use strict';

  const Security = window.PaymentLockSecurity;
  const cfgEl = document.getElementById('payment-lock-config') || document.getElementById('payment-lock-guard-config');

  if (!cfgEl) return;

  let cfg = {};
  try {
    cfg = JSON.parse(cfgEl.textContent);
  } catch {
    return;
  }

  if (!cfg.enabled) return;

  const AUTH_KEY = 'payment_lock_authorized_v1';

  function hasValidSessionDirect() {
    try {
      const raw = localStorage.getItem('payment_lock_session_v1');
      if (!raw) return false;
      const session = JSON.parse(raw);
      if (!session?.expiresAt) return false;
      if (Date.now() > session.expiresAt) {
        localStorage.removeItem('payment_lock_session_v1');
        return false;
      }
      return true;
    } catch {
      localStorage.removeItem('payment_lock_session_v1');
      return false;
    }
  }

  function isAuthorizedRemovalDirect(cfg) {
    const revision = cfg.disableRevision || cfg.revision;
    if (!revision) return false;

    try {
      const disabled = JSON.parse(localStorage.getItem('payment_lock_disabled_v1') || 'null');
      const auth = JSON.parse(localStorage.getItem(AUTH_KEY) || 'null');
      return Boolean(
        disabled?.revision === revision &&
        auth?.authorized &&
        auth?.revision === revision
      );
    } catch {
      return false;
    }
  }

  function isAuthorizedRemoval() {
    if (isAuthorizedRemovalDirect(cfg)) return true;
    if (!Security) return false;
    const disabled = Security.isPermanentlyDisabled(cfg.disableRevision || cfg.revision);
    if (!disabled) return false;

    try {
      const auth = JSON.parse(localStorage.getItem(AUTH_KEY) || 'null');
      return Boolean(auth?.authorized && auth?.revision === (cfg.disableRevision || cfg.revision));
    } catch {
      return false;
    }
  }

  function shouldEnforce() {
    if (isAuthorizedRemoval()) return false;
    if (hasValidSessionDirect()) return false;
    if (Security?.hasValidSession()) return false;
    return true;
  }

  function releaseInteraction() {
    document.documentElement.classList.remove('payment-lock-active');
    document.querySelector('.page-wrapper')?.removeAttribute('inert');

    document.querySelectorAll('[data-pl-locked]').forEach((el) => {
      el.removeAttribute('tabindex');
      el.removeAttribute('aria-hidden');
      el.removeAttribute('data-pl-locked');
    });
  }

  function hideOverlay() {
    const overlay = document.getElementById('payment-lock-overlay');
    if (!overlay) return;
    overlay.classList.remove('is-visible', 'pl-animate-fade-in');
    overlay.classList.add('is-hidden');
    overlay.setAttribute('aria-hidden', 'true');
  }

  function lockInteraction() {
    document.documentElement.classList.add('payment-lock-active');

    const wrapper = document.querySelector('.page-wrapper');
    if (wrapper) wrapper.setAttribute('inert', '');

    document.querySelectorAll('a, button, input, select, textarea').forEach((el) => {
      if (el.closest('#payment-lock-overlay')) return;
      el.setAttribute('tabindex', '-1');
      el.setAttribute('aria-hidden', 'true');
      el.setAttribute('data-pl-locked', 'true');
    });
  }

  function blockNavigation(event) {
    if (!shouldEnforce()) return;
    const target = event.target;
    if (target?.closest?.('#payment-lock-overlay')) return;
    event.preventDefault();
    event.stopPropagation();
    window.__paymentLockGuardInit || document.dispatchEvent(new CustomEvent('payment-lock:tamper'));
  }

  function bindTamperListeners() {
    ['click', 'submit', 'keydown'].forEach((type) => {
      document.addEventListener(type, blockNavigation, true);
    });
  }

  function checkIntegrity() {
    if (!shouldEnforce()) {
      releaseInteraction();
      hideOverlay();
      return;
    }

    const overlay = document.getElementById('payment-lock-overlay');
    const configMissing = !document.getElementById('payment-lock-config') && !document.getElementById('payment-lock-guard-config');
    const assetsMissing = !window.PaymentLockSecurity && !document.getElementById('payment-security-js');

    if (!overlay || configMissing || assetsMissing) {
      lockInteraction();
      document.dispatchEvent(new CustomEvent('payment-lock:tamper-detected'));
    }

    if (overlay && !overlay.classList.contains('is-visible')) {
      overlay.classList.add('is-visible');
      lockInteraction();
    }
  }

  if (shouldEnforce()) {
    bindTamperListeners();
    checkIntegrity();
    setInterval(checkIntegrity, 2500);
  } else {
    releaseInteraction();
    hideOverlay();
  }

  window.PaymentLockTamperGuard = { isAuthorizedRemoval, shouldEnforce, checkIntegrity };
})();
